import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class InscripcionService {

  constructor(private firestore: AngularFirestore) { }

  public insertarIncripcion(alumno, tutor, idAlumno, idTutor): any{
    return this.firestore.collection('inscriptions').doc(alumno?.lastInscripcionId).set({
      appCreacion: 'nuevapantalla',
      active: true,
      address: tutor?.address || '',
      alumns: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/users/${idAlumno}`)),
      city: tutor?.city || '',
      cp: tutor?.zip || '',
      dob: alumno?.dobTimestamp || '',
      document: tutor?.document || '',
      email: tutor?.email || '',
      firstname: alumno?.firstname || '',
      firstnameStudent: alumno?.firstname || '',
      lastname: alumno?.lastname || '',
      municipality: tutor?.municipality || '',
      numberDNI: tutor?.numberDNI || '',
      parentesco: tutor?.parentesco || '',
      phone1: tutor?.phone1 || '',
      registrationDate: new Date(),
      sexoStudent: alumno?.sexo || '',
      status: alumno?.status || '',
      tipoVia: tutor?.tipoVia || '',
      tutors: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/users/${idTutor}`)),
      userType: 'inscription',
      idUserAlumno: idAlumno,
      prevStatus : alumno?.status || '',
      lastnameStudent : alumno?.lastname || '',
      dobStudent : '',
      age : alumno?.age || '',
      ageStudent : alumno?.age || '',
      sexo : alumno?.sexo || '',
      documentStudent : alumno?.document || '',
      numberDNIStudent : alumno?.numberDNI  || '',
      number : '',
      municipio : alumno?.municipality || '',
      courseSelectedTime : new Date(),
      showInscription : !alumno?.showStudent || true
    });
  }

  public obtenerInscripcionPorAlumno(idAlumno): any{
    return this.firestore.collection('inscriptions',
      ref => ref.where('idUserAlumno', '==', idAlumno)).get();
  }

  public actualizarIncripcion(idInscripcion, alumno): any {
    return this.firestore.collection('inscriptions').doc(idInscripcion).update({
      centro: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/users/${alumno.centroId}`)),
      courses: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/courses/${alumno.cursoElegido.id}`)),
      dia: alumno?.dia || '',
      horario: alumno?.horaSeleccionada || '',
      areaInterest: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/area_interest/${alumno.cursoElegido.area.id}`)),
      status: alumno.status,
      registrationDate : alumno?.cursoElegido?.registrationDate,
      codePromocionalId : firebase.firestore().doc(`/codes/${alumno?.codigoId}`),
      showInscription : alumno?.showInscription
    });
  }

  public eliminarInscripcion(idInscripcion): any {
    return this.firestore.collection('inscriptions').doc(idInscripcion).update({
      centro: firebase.firestore.FieldValue.delete(),
      courses: firebase.firestore.FieldValue.delete(),
      dia: '',
      horario: '',
      areaInterest: firebase.firestore.FieldValue.delete(),
      status : 'prospectivo',
      courseSelectedTime : firebase.firestore.FieldValue.delete(),
      codePromocionalId : firebase.firestore.FieldValue.delete(),
      showInscription : true

    });

  }

  public actualizarIncripcionListaEspera(idInscripcion, alumno): any{
    return this.firestore.collection('inscriptions').doc(idInscripcion).update({
      centro: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/users/${alumno.centroId}`)),
      dia: alumno?.dia || '',
      horario: alumno?.horaCursoSeleccionada || '',
      areaInterest: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/area_interest/${alumno.areaId}`)),
      status: 'espera',
      showInscription : alumno?.showInscription || true
    });
  }

  public actualizarEstadoInscripcion(idInscripcion, statusInscription): any {
    return this.firestore.collection('inscriptions').doc(idInscripcion).update({
      status: statusInscription,
    });
  }
  public updateUserCourseSelectedTime(id, date): any {
    return this.firestore.collection('inscriptions').doc(id).update({
      courseSelectedTime: date,
    });
  }

  public eliminarInscripcionRegistro(inscriptcionId): any{
    return this.firestore.collection('inscriptions').doc(inscriptcionId).delete();
  }

  public updateInscripcionRegistro(alumno, tutor, inscriptionId): any{
    return this.firestore.collection('inscriptions').doc(inscriptionId).update({
      active: false,
      address: tutor?.address || '',
      city: tutor?.city || '',
      cp: tutor?.zip || '',
      dob: alumno?.dob || '',
      document: tutor?.document || '',
      email: tutor?.email || '',
      firstname: alumno?.firstname || '',
      firstnameStudent: alumno?.firstname || '',
      lastname: alumno?.lastname || '',
      fullname : alumno?.firstname || '' + ' ' + alumno?.lastname || '',
      municipality: tutor?.municipality || '',
      numberDNI: tutor?.numberDNI || '',
      parentesco: tutor?.parentesco || '',
      phone1: tutor?.phone1 || '',
      registrationDate: new Date(),
      sexoStudent: alumno?.sexo || '',
      status: alumno?.status || '',
      tipoVia: tutor?.tipoVia || '',
      userType: 'inscription',
      prevStatus : alumno?.status || '',
      lastnameStudent : alumno?.lastname || '',
      dobStudent : '',
      age : alumno?.age || '',
      ageStudent : alumno?.age || '',
      sexo : alumno?.sexo || '',
      documentStudent : alumno?.document || '',
      numberDNIStudent : alumno?.numberDNI  || '',
      number : '',
      municipio : alumno?.municipality || '',
      courseSelectedTime : new Date()
    });
  }

}
